import React from "react";
import "./Disclaimer.css"; 

const Disclaimer = () => {
  return (
    <div className="disclaimer-container">
      <p className="disclaimer-text">
        Not what you wanted? You can also click on other tabs near the top of
        the page to browse other resources.
      </p>
    </div>
  );
};

export default Disclaimer;
